import { clubApi } from '@repo/api-client';
import { useNavigate } from 'react-router';
import { urlTournament } from '@/urls';
import { useForm } from '@repo/ui/hooks/use-form';
import { Input } from '@repo/ui/components/form/input';
import { Button } from '@repo/ui/components/button';
import { FormErrors } from '@repo/shared-types';

interface CreateTournamentFormProps {
  clubId: string;
}

const customValidate = (values: Partial<Tournament>) => {
  const errors: FormErrors = {};
  if (values.startDate && values.endDate && new Date(values.startDate) > new Date(values.endDate)) {
    errors.endDate = { message: 'La fecha de fin debe ser mayor que la fecha de inicio' };
  }
  return errors;
};

export const CreateTournamentForm = ({ clubId }: CreateTournamentFormProps) => {
  const navigate = useNavigate();

  const onSubmit = async () => {
    const result = await clubApi.createTournament(clubId, values);
    navigate(urlTournament(clubId.toString(), result.id.toString()));
  };

  const { ref, values, errors } = useForm<CreateTournament>({
    initialValues: {
      name: '',
      startDate: '',
      endDate: '',
    },
    customValidate,
    onSubmit,
  });

  return (
    <form ref={ref} className="grid gap-4">
      <Input label="Nombre" type="text" name="name" required errors={errors} />
      <Input label="Desde" type="date" name="startDate" required errors={errors} />
      <Input label="Hasta" type="date" name="endDate" required errors={errors} />
      <Button type="submit">Crear</Button>
    </form>
  );
};
